module.exports = __webpack_public_path__ + "img/example.31e19b12.png";